import {
  SEARCH_INPUT_SUPPLIER_FILTER1_BUYER,
  SEARCH_OPTION_SUPPLIER_FILTER2_BUYER,
  SEARCH_OPTION_SUPPLIER_FILTER3_BUYER,
  SEARCH_OPTION_SUPPLIER_FILTER4_BUYER,
} from './constants'

export const filterSearchInput1 = (search, enterEvent = null) => ({
  type: SEARCH_INPUT_SUPPLIER_FILTER1_BUYER,
  searchValue: search,
  enterSearchInputFilter: enterEvent,
})
export const filterSearchOptions2 = (search, selectSearchOption = null) => ({
  type: SEARCH_OPTION_SUPPLIER_FILTER2_BUYER,
  searchOption2: search,
  selectedOptions2: selectSearchOption,
})
export const filterSearchOptions3 = (search, selectSearchOption = null) => ({
  type: SEARCH_OPTION_SUPPLIER_FILTER3_BUYER,
  searchOption3: search,
  selectedOptions3: selectSearchOption,
})
export const filterSearchOptions4 = (search, selectSearchOption = null) => ({
  type: SEARCH_OPTION_SUPPLIER_FILTER4_BUYER,
  searchOption4: search,
  selectedOptions4: selectSearchOption,
})
